import { QueryClient } from "@tanstack/react-query";
export class QueryClientSingleton {
  static instance;
  client;
  constructor(){
    this.client = new QueryClient();
  }
  static getInstance() {
    if (!QueryClientSingleton.instance) {
      QueryClientSingleton.instance = new QueryClientSingleton();
    }
    return QueryClientSingleton.instance;
  }
  getClient() {
    return this.client;
  }
}
export const getQueryClient = (client)=>{
  console.info('getting query client');
  if (typeof window === 'undefined') {
    return QueryClientSingleton.getInstance().getClient();
  }
  const typedWindow = window;
  if (typeof typedWindow !== 'undefined' && typedWindow.cliengo_query_client) {
    console.info('returning client from window');
    return typedWindow.cliengo_query_client;
  }
  if (client) {
    console.info('returning client from param');
    return client;
  }
  console.info('returning client from singleton');
  return QueryClientSingleton.getInstance().getClient();
};
export const invalidateQuery = (queryKey)=>{
  return getQueryClient().invalidateQueries({
    queryKey
  });
};
//# sourceMappingURL=reactQuery.client.js.map